import React, { useState } from "react";
import { FormFieldSet } from "../../../../../../../components";

const ByUser = ({ value = [], onChange }) => {
  return (
    <div className="p-2">
      <p className="text-sm text-gray-600 my-3">
        Pick roles and users to give access to the scheduled Resume Mining
        feature.
      </p>
      <div className="flex flex-col gap-3 w-full md:w-[280px] ">
        <FormFieldSet
          type="allUsers"
          title="By User"
          placeholder="Select User"
          // value={value?.map(item =>
          //   typeof item === "object"
          //     ? item?.uiid
          //     : item)}
          value={value}
          onChange={onChange}
          shadow
          showSearch
          //{...(value?.length && { filters: { condition: 200 } })}
          filters={{uiids:value}}
          multiple={true}
        />
      </div>
    </div>
  );
};

export default ByUser;
